import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { config } from '@app/core/app-config';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType } from '@app/shared/interfaces';
import { DeviceDetectionService } from '@app/shared/services/device-detection/device-detection.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { ForgotPwFormComponent } from '../../components/forgot-pw-form/forgot-pw-form.component';

@Component({
  standalone: false,
  selector: 'sbnb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public mode: 'login' | 'forgotpw' | 'link' | 'email' | 'code';
  public returnUrl: string;

  config = config;

  public email: string; // An email address to pre-fill

  magicLinkCode = '';

  @ViewChild('forgotPwCmp') forgotPwCmp: ForgotPwFormComponent;
  loading: boolean;

  isAndroid = this.device.isAndroidApp();
  isDeviceAlreadyTrusted: any;
  loadingTrust: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private auth: AuthenticationService,
    private toast: ToastNotificationsService,
    private device: DeviceDetectionService
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      this.email = params['email'];
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.returnUrl = params['returnUrl'];
      this.mode = params['mode'] || 'login';
    });
  }

  routeToMagicLink(newState: {
    mode: 'login' | 'forgotpw' | 'link' | 'email' | 'code';
    email: string;
    trusted: boolean;
  }) {
    this.mode = newState.mode;
    this.email = newState.email;
    this.isDeviceAlreadyTrusted = newState.trusted;
  }

  processMagicCodeLogin(trust: boolean) {
    this.loading = !trust;
    this.loadingTrust = trust;

    this.auth.useLoginMagicCode(this.email, this.magicLinkCode, trust).subscribe(
      (res: any) => {
        this.loading = false;
        this.loadingTrust = false;

        const user = res.data;

        localStorage.setItem('accessToken', user.token);

        setTimeout(() => {
          this.auth.getUserDetailsFromApi().subscribe((res) => {
            localStorage.setItem('user', JSON.stringify(res));

            this.auth.loginActions(config.DEFAULT_PAGE);
          });
        }, 100);
      },
      (err) => {
        this.loading = false;
        this.loadingTrust = false;
        this.toast.open(err.error.message || 'Incorrect code', 'Dismiss', NotificationType.Error, 2500);
      }
    );
  }
}
